import * as React from "react";

import {
  Button,
  makeStyles,
  ButtonProps as MuiButtonProps,
  Theme,
} from "@material-ui/core";

export type MopButtonVariant =
  | "primary"
  | "secondary"
  | "tertiary"
  | "default"
  | undefined;

type MopButtonProps = MuiButtonProps & {
  mopVariant: MopButtonVariant;
  component?: React.ElementType;
};

const useStyles = makeStyles((theme: Theme) => ({
  tertiary: {
    "&.MuiButton-contained": {
      border: `1px solid ${theme.palette.common.black}`,
      background: theme.palette.common.white,
    },
  },
}));

export const MopButton: React.FC<MopButtonProps> = ({
  mopVariant,
  ...rest
}) => {
  const classes = useStyles();

  // white with black text
  const tertiary = (
    <Button variant="contained" className={classes.tertiary} {...rest} />
  );

  // bondi mint with black text
  const primary = <Button variant="contained" color="primary" {...rest} />;

  // black with white text
  const secondary = <Button variant="contained" color="secondary" {...rest} />;

  // gray with black text
  const defaultButton = (
    <Button variant="contained" color="default" {...rest} />
  );

  if (mopVariant === "primary") return primary;
  if (mopVariant === "secondary") return secondary;
  if (mopVariant === "tertiary") return tertiary;
  if (mopVariant === "default") return defaultButton;

  // Default return statement, e.g., if variant is not one of the specified values
  return <Button {...rest} />;
};
